import {BalloonEventModel} from 'ts-core';
import React from 'react';
import {AddCalendarButton} from './AddCalendarButton';
import {BookmarkButton} from './BookmarkButton';
import {ShareButton} from './ShareButton';
import {OpenOnMapButton} from './OpenOnMapButton';

export type EventAction = 'save' | 'calendar' | 'share' | 'openOnMap';

export interface EventActionBarProps {
    event: BalloonEventModel;
    actions?: EventAction[];
    trackingSource?: string;
    className?: string;
}

export const EventActionBar: React.FC<EventActionBarProps> = ({
                                                                  event,
                                                                  actions = ['save', 'calendar', 'share', 'openOnMap'],
                                                                  trackingSource,
                                                                  className,
                                                              }) => {
    return (
        <div className={className ?? 'event-action-bar flex flex-row gap-2 items-center'}>
            {actions.includes('save') && (
                <BookmarkButton event={event} toolbar={true} trackingSource={trackingSource}/>
            )}
            {actions.includes('calendar') && (
                <AddCalendarButton event={event} trackingSource={trackingSource}/>
            )}
            {actions.includes('share') && (
                <ShareButton event={event} trackingSource={trackingSource}/>
            )}
            {actions.includes('openOnMap') && (
                <OpenOnMapButton event={event} trackingSource={trackingSource}/>
            )}
        </div>
    );
};
